module.exports = __webpack_public_path__ + "img/step_5.a374bdeb.svg";